module.exports = __webpack_public_path__ + "img/person-plug-mini.c27ed96c.png";